export default "__VITE_ASSET__DuI7jNIl__"